import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 2h6a1 1 0 0 1 1 1v18a1 1 0 0 1 -1 1h-6a2 2 0 0 1 -2 -2v-16a2 2 0 0 1 2 -2","key":"svg-0"}],["path",{"d":"M14 2h6a2 2 0 0 1 2 2v16a2 2 0 0 1 -2 2h-6a1 1 0 0 1 -1 -1v-18a1 1 0 0 1 1 -1","key":"svg-1"}]]

const IconColumns2Filled = createReactComponent('filled', 'columns-2-filled', 'Columns2Filled', __iconNode);

export default IconColumns2Filled;